<tds-modal size="md" closeIconButtonLabel="Close">
  <tds-modal-title>New Region Manager for {{ source().name }}</tds-modal-title>
  <div class="region-manager-form">
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <mat-select [value]="selectedUserId()" (selectionChange)="onUserChange($event.value)">
        <mat-option [value]="undefined">None</mat-option>
        @for (user of users(); track user.id) {
          <mat-option [value]="user.id">{{ userLabel(user) }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (userError()) {
      <span class="region-manager-error">Select an email.</span>
    }
    <mat-form-field appearance="outline">
      <mat-label>Market Area</mat-label>
      <mat-select [value]="selectedMarketAreaId()" (selectionChange)="onMarketAreaChange($event.value)">
        <mat-option [value]="undefined">None</mat-option>
        @for (marketArea of marketAreasViewModel().marketAreas; track marketArea.id) {
          <mat-option [value]="marketArea.id">{{ marketArea.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (duplicateError()) {
      <span class="region-manager-error">An active Region Manager already exists for this market area.</span>
    }
    <div class="region-manager-field">
      <label class="region-manager-field-label" for="region-manager-first-name">First name</label>
      <input id="region-manager-first-name" type="text" class="region-manager-input" placeholder="John" [value]="firstName()" (input)="onFirstNameChange($event)" />
    </div>
    <div class="region-manager-field">
      <label class="region-manager-field-label" for="region-manager-last-name">Last name</label>
      <input id="region-manager-last-name" type="text" class="region-manager-input" placeholder="Doe" [value]="lastName()" (input)="onLastNameChange($event)" />
    </div>
    @if (regionManagerViewModel().error) {
      <div class="region-manager-error">{{ regionManagerViewModel().error }}</div>
    }
  </div>
  <tds-modal-actions>
    <button tds-button variant="tertiary" (click)="close()">Cancel</button>
    <button tds-button (click)="save()" [disabled]="regionManagerViewModel().isSaving">Save</button>
  </tds-modal-actions>
</tds-modal>
